import { HttpContextToken } from '@angular/common/http';

/**
 * HttpContextToken pour identifier les requêtes nécessitant une authentification
 * Par défaut, les requêtes n'ont pas besoin d'authentification (false)
 */
export const REQUIRES_AUTH = new HttpContextToken<boolean>(() => false);
